// src/services/CountryService.js
import api from "./api";

export function getUniversity(page = 1, limit = 10, search = "") {
    return api.get(`/university?page=${page}&limit=${limit}&search=${search}`);
}

export function getUniversityById(id) {
    return api.get(`/university/${id}`);
}

export function addUniversity(data) {
    return api.post("/university", data);
}

export function updateUniversity(id, data) {
    return api.put(`/university/${id}`, data);
}

export function deleteUniversity(id) {
    return api.delete(`/university/${id}`);
}
